import comp from '../components/barrel';
import userCommsLog from './VUt_User_commslog';

const SEND_EP = 'advisors/send-advisor-direct-email';

function advisorUuid() {
  const fromVars =
    (thsPage && thsPage.vars && thsPage.vars.advisor_uuid) ||
    (thsTab && thsTab.vars && thsTab.vars.advisor_uuid);
  const fromDetails = thsPage && thsPage.advisorDetails && thsPage.advisorDetails.advisor_uuid;
  const raw = fromVars != null && String(fromVars).trim() !== '' ? fromVars : fromDetails;
  return raw ? String(raw).trim() : '';
}

function setFieldFeedback(el, message) {
  if (!el) return;
  const fb = document.querySelector(`[fb-for="${el.id}"]`);
  if (fb) fb.textContent = message || '';
  if (message) el.classList.add('input-error');
  else el.classList.remove('input-error');
}

export default {
  ...userCommsLog,
  hideCommsRecipientFilter: true,

  async prepare() {
    const uuid = advisorUuid();
    if (thsPage && thsPage.vars) {
      thsPage.vars.target_user_uuid = uuid;
    }
    return userCommsLog.prepare.call(this);
  },

  async showEmailAdvisorForm() {
    const wrap = U.id('emailAdvisorForm');
    if (!wrap) return;
    U.unhide('emailAdvisorForm');
    if (wrap.dataset.built === '1') {
      const subject = U.id('emailAdvisorSubject');
      if (subject) subject.focus();
      return;
    }
    wrap.dataset.built = '1';
    wrap.innerHTML = '';

    const subjectField = await comp.inputText('emailAdvisorSubject', '', 'Email subject', 1, '', '');
    const bodyField = await comp.textarea('emailAdvisorBody', '', 'Email body', 1);
    bodyField.classList.remove('col-span-full');
    const bodyInput = bodyField.querySelector('#emailAdvisorBody');
    if (bodyInput) bodyInput.style.minHeight = '8rem';

    const sendBtn = document.createElement('button');
    sendBtn.type = 'button';
    sendBtn.id = 'emailAdvisorSendBtn';
    sendBtn.className = 'btn';
    sendBtn.textContent = 'Send email';
    sendBtn.setAttribute('onclick', 'thsTab.sendAdvisorDirectEmail()');

    wrap.appendChild(subjectField);
    wrap.appendChild(bodyField);
    wrap.appendChild(sendBtn);

    const subject = U.id('emailAdvisorSubject');
    if (subject) subject.focus();
  },

  async sendAdvisorDirectEmail() {
    const subjectEl = U.id('emailAdvisorSubject');
    const bodyEl = U.id('emailAdvisorBody');
    const sendBtn = U.id('emailAdvisorSendBtn');
    const subject = subjectEl ? String(subjectEl.value || '').trim() : '';
    const body = bodyEl ? String(bodyEl.value || '').trim() : '';

    let valid = true;
    if (!subject) {
      setFieldFeedback(subjectEl, 'Email subject is required');
      valid = false;
    } else {
      setFieldFeedback(subjectEl, '');
    }
    if (!body) {
      setFieldFeedback(bodyEl, 'Email body is required');
      valid = false;
    } else {
      setFieldFeedback(bodyEl, '');
    }
    if (!valid) return;

    const target_user_uuid = advisorUuid();
    if (!target_user_uuid) {
      comp.toast('No advisor selected');
      return;
    }

    if (sendBtn) sendBtn.disabled = true;

    try {
      const res = await O.PREP([
        await O.mPOST(SEND_EP, {
          target_user_uuid,
          placeholder_values: {
            bodyreplace1: body,
            email_subject: subject,
          },
        }),
      ]);
      const sendRes = res[SEND_EP] || {};
      if (sendRes.status === 'OK') {
        if (subjectEl) subjectEl.value = '';
        if (bodyEl) bodyEl.value = '';
        U.hide('emailAdvisorForm');
        comp.toast('Email sent');
        if (typeof this.fetchCommsLog === 'function') {
          await this.fetchCommsLog();
        }
        return;
      }
      const err = sendRes.data && sendRes.data.error;
      comp.toast(err || 'Unable to send email');
    } catch (e) {
      comp.toast('Unable to send email');
    } finally {
      if (sendBtn) sendBtn.disabled = false;
    }
  },
};
